if (!customElements.get('asobu-retail-product-controls')) {
  customElements.define('asobu-retail-product-controls', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section || this.events) return;
      this.events = new AbortController();
      this.origins = new Map();
      this.wide = window.matchMedia('(min-width: 1000px)');
      this.wide.addEventListener('change', () => this.layoutDetails(), { signal: this.events.signal });
      this.section.addEventListener('product:rerender', () => requestAnimationFrame(() => {
        if (this.isConnected) this.layoutDetails();
      }), { signal: this.events.signal });
      this.layoutDetails();
      const options = { signal: this.events.signal, passive: true };
      const schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateSticky();
        });
      };
      window.addEventListener('scroll', schedule, options);
      window.addEventListener('resize', schedule, options);
      this.section.addEventListener('product:rerender', schedule, options);
      this.section.addEventListener('toggle', schedule, { ...options, capture: true });
      this.section.addEventListener('change', schedule, options);
      this.updateSticky();
    }
    disconnectedCallback() {
      this.restoreDetails();
      this.events?.abort();
      this.events = null;
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    restoreDetails() {
      if (!this.origins) return;
      for (const [node, marker] of this.origins) {
        if (marker.isConnected) marker.replaceWith(node);
      }
      this.origins.clear();
    }
    layoutDetails() {
      if (!this.wide.matches) { this.restoreDetails(); return; }
      const target = this.section.querySelector('[data-asobu-desktop-specs]');
      if (!target) return;
      for (const [node, marker] of this.origins) {
        if (!marker.isConnected) this.origins.delete(node);
      }
      for (const block of this.section.querySelectorAll('.product-info [data-asobu-detail]')) {
        if (!block.textContent.trim()) continue;
        const marker = document.createComment('Retail product detail');
        block.before(marker);
        this.origins.set(block, marker);
        target.append(block);
      }
    }
    updateSticky() {
      const sticky = this.section.querySelector('[data-asobu-retail-sticky]');
      if (!sticky) return;
      const button = this.section.querySelector('.product-info buy-buttons button[type="submit"]');
      const pastButton = button && button.getBoundingClientRect().bottom <= 0;
      let overlapsDetails = false;
      if (pastButton && window.innerWidth < 1000) {
        const band = window.innerHeight - 64;
        const details = this.section.querySelectorAll('[data-block-type="description"], [data-block-type="collapsible-text"] details[open]');
        overlapsDetails = Array.from(details).some(detail => {
          const rect = detail.getBoundingClientRect();
          return rect.height > 0 && rect.top < window.innerHeight && rect.bottom > band;
        });
      }
      sticky.toggleAttribute('data-asobu-buy-passed', Boolean(pastButton && !overlapsDetails));
    }
  });
}
